module.exports = __webpack_public_path__ + "img/21_56.8c58f13b.png";